import React from 'react';
import { Activity } from 'lucide-react';
import useCrousLive from '../../../hooks/useCrousLive';

function labelFor(level) {
  if (level === null || level === undefined) return 'Pas de données';
  if (level < 0.7) return 'Vide';
  if (level < 1.5) return 'Moyen';
  return 'Blindé';
}

function classFor(level) {
  if (level === null || level === undefined) return 'est-live-badge est-live-unknown';
  if (level < 0.7) return 'est-live-badge est-live-low';
  if (level < 1.5) return 'est-live-badge est-live-mid';
  return 'est-live-badge est-live-high';
}

function CrousLiveBadge({ crousId }) {
  const { level, count } = useCrousLive(crousId);
  return (
    <span className={classFor(level)}>
      <Activity size={12} />
      {labelFor(level)}
      <small>{count > 0 ? `${count} ping${count > 1 ? 's' : ''} / 15 min` : 'aucun ping'}</small>
    </span>
  );
}

export default CrousLiveBadge;
